require('./bootstrap');

var meta_c = $('meta[name=csrf-token]').attr("content");

$(function() {
    $(window).on('resize', function(){
        toastInit();
    });

    $(window).on('scroll', function(){
        toastInit();
    });

    toastInit();
    function toastInit() {
        if($('.toast-c').length){
            if($(window).scrollTop() >= $('.toast-c').offset().top){
                $('.toast-c .spacer').height($('.toast-c .toast-bar').height());
                $('.toast-c .toast-bar').addClass('fixed-top');
            }else{
                $('.toast-c .spacer').height(0);
                $('.toast-c .toast-bar').removeClass('fixed-top');
            }
        }
    }
});

function onResize() {
    if(!window.matchMedia("(min-width: 1200px)").matches){
        if($('#menu-t-btn').hasClass('side-nav-show')){
            $('#menu-t-btn').trigger('click');
        }
    }
}

$(window).on('resize', function(){
    onResize();
});
$(window).on('load', function(){
    onResize();
});

am4core.ready(function() {
    am4core.useTheme(am4themes_animated);
    am4core.useTheme(am4themes_material);
});
window.am4core = am4core;
window.am4charts = am4charts;